import React, { forwardRef } from 'react';
import { Table as MuiTable } from '@mui/material';
import { isEmpty } from 'lodash';

import { reportErrorInProductionOrThrow } from '~/Utils';

/**
 This Component is a wrapper on MUI component.
 This component should be imported and not MUI directly!
**/

/**
 * Explicit Table props based on actual usage in the codebase.
 */
export interface TableProps {
  /** CSS class name to apply to the root element */
  className?: string;
  /** Inline styles applied to the root element */
  style?: React.CSSProperties;
  /** Identifies the element that labels the table */
  'aria-labelledby'?: string;
  /** The content of the table (header, body, footer rows) */
  children?: React.ReactNode;
}

// ref is forwarded so parents that need the DOM node keep working through the wrapper.
const Table = forwardRef<HTMLTableElement, TableProps>(
  ({ className, style, 'aria-labelledby': ariaLabelledBy, children, ...restProps }, ref) => {
    if (!isEmpty(restProps)) {
      reportErrorInProductionOrThrow(
        `Unexpected props passed to Table: ${Object.keys(restProps).join(', ')}.
Examine if these need to be removed, or added explicitly to the TableProps interface and to the component's signature.`,
        true
      );
    }
    return (
      <MuiTable ref={ref} className={className} style={style} aria-labelledby={ariaLabelledBy} {...restProps}>
        {children}
      </MuiTable>
    );
  }
);

Table.displayName = 'Table';

export default Table;
